export class ItemDemandaCmd {
    id: number = -'';
    nome: string = '';
    especificacao: string = ";"
    quantidade: number = 0;
    valorUnitario: number = 0;
}
